import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const errMsg = (e, fallback) => e.response?.data?.detail || fallback;

const toDigits = (raw) => {
  const d = raw.replace(/\D/g, "");
  return d.length === 12 && d.startsWith("91") ? d.slice(2) : d;
};

function PhoneStep({ phone, setPhone, onSend, busy, wait, tid }) {
  const digits = toDigits(phone);
  return (
    <>
      <label>Mobile number</label>
      <div className="phone-field">
        <span>+91</span>
        <input data-testid={`${tid}-phone-input`} value={phone} onChange={(e) => setPhone(e.target.value)}
          placeholder="98765 43210" inputMode="tel" maxLength="14" autoComplete="tel-national" />
      </div>
      <button className="primary full" data-testid={`${tid}-send-otp-button`} onClick={onSend} disabled={busy || digits.length !== 10 || wait > 0}>
        {busy ? "Sending…" : wait > 0 ? `Send OTP in ${wait}s` : "Send OTP"}
      </button>
    </>
  );
}

function CodeStep({ phone, sent, code, setCode, name, setName, askName, wait, busy, onVerify, onResend, onChange, tid }) {
  return (
    <>
      <div className="otp-sent-to" data-testid={`${tid}-sent-to`}>
        Code sent to <strong>+91 {phone}</strong>
        <button className="link-btn" data-testid={`${tid}-change-number`} onClick={onChange}>Change</button>
      </div>
      {askName && (<><label>Your name <em>optional</em></label>
        <input data-testid={`${tid}-name-input`} value={name} onChange={(e) => setName(e.target.value)} placeholder="What should we call you?" /></>)}
      <label>Enter OTP</label>
      <input data-testid={`${tid}-otp-input`} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
        placeholder="6-digit code" maxLength="6" inputMode="numeric" autoComplete="one-time-code" />
      {sent.mode === "demo" && <div className="demo-note" data-testid={`${tid}-demo-note`}>Demo mode (no SMS sent yet): use OTP <strong>{sent.demo_code}</strong></div>}
      <button className="primary full" data-testid={`${tid}-verify-button`} onClick={onVerify} disabled={busy || code.length !== 6}>
        {busy ? "Checking…" : "Verify & continue"}
      </button>
      <button className="link-btn otp-resend" data-testid={`${tid}-resend-button`} onClick={onResend} disabled={busy || wait > 0}>
        {wait > 0 ? `Resend code in ${wait}s` : "Resend code"}
      </button>
    </>
  );
}

export const OtpLogin = ({ role = "customer", onLogin, askName = false, testPrefix = "auth" }) => {
  const [phone, setPhone] = useState(""); const [code, setCode] = useState(""); const [name, setName] = useState("");
  const [sent, setSent] = useState(null); const [wait, setWait] = useState(0);
  const [busy, setBusy] = useState(false); const [error, setError] = useState("");
  const [sentPhone, setSentPhone] = useState("");
  const digits = toDigits(phone);
  const cooldown = digits === sentPhone ? wait : 0;
  useEffect(() => {
    if (wait <= 0) return undefined;
    const t = setTimeout(() => setWait((w) => w - 1), 1000);
    return () => clearTimeout(t);
  }, [wait]);
  const run = async (fn, fallback) => {
    setError(""); setBusy(true);
    try { await fn(); } catch (e) { setError(errMsg(e, fallback)); } finally { setBusy(false); }
  };
  const send = () => run(async () => {
    const r = await axios.post(`${API}/auth/request-otp`, { phone: digits, role });
    setSent(r.data); setWait(r.data.resend_after); setSentPhone(digits); setCode("");
  }, "Please check your number");
  const verify = () => run(async () => {
    const r = await axios.post(`${API}/auth/verify-otp`, { phone: digits, code, name, role });
    onLogin(r.data.user);
  }, "Could not verify OTP");
  return (
    <div className="otp-login" data-testid={`${testPrefix}-otp-login`}>
      {!sent
        ? <PhoneStep phone={phone} setPhone={setPhone} onSend={send} busy={busy} wait={cooldown} tid={testPrefix} />
        : <CodeStep phone={digits} sent={sent} code={code} setCode={setCode} name={name} setName={setName} askName={askName}
            wait={wait} busy={busy} onVerify={verify} onResend={send} onChange={() => { setSent(null); setCode(""); setError(""); }} tid={testPrefix} />}
      {error && <div className="error" data-testid={`${testPrefix}-error`}>{error}</div>}
    </div>
  );
};
